import React, { useState, useMemo, useEffect } from "react";
import DataTable from "react-data-table-component";
import Button from 'react-bootstrap/Button';
import { Modal, OverlayTrigger, Stack, Toast, ToastContainer } from "react-bootstrap";
import moment from "moment";
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { FaSpinner } from 'react-icons/fa';
import SweetAlert from "react-bootstrap-sweetalert";
import { Tooltip } from '@mui/material';
import { BiExport } from "react-icons/bi";
import AdminMaster from "../../../Layout/admin/Master";
import Select, { components } from 'react-select';
import { addDays, addMonths, endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfWeek, startOfYear, subDays, setHours, setMinutes, setSeconds } from "date-fns";
import ClientDropDown from "../../common/PartnerClientFacilityDropDown/ClientDropDown";
import FacilityDropDown from "../../common/PartnerClientFacilityDropDown/FacilityDropDown";
import PartnerDropDown from "../../common/PartnerClientFacilityDropDown/PartnerDropDown";
import FilterComponent from "../../common/FilterComponent";
import TableHeadings from "../../common/TableHeadings";
import { downloadFile } from "../Dashboard/functions";
import queueDatatableCustomStyles from "../../../Layout/Elements/QueueDatatableCustomStyles";
import * as Yup from 'yup';
import { useFormik } from "formik";  
import useFilter from "../../../hooks/useFilter";
import axiosInstance from "../../../axiosInstance";
import DateRangePicker from 'rsuite/DateRangePicker';
import { getExceptionRecordTable } from "../../../Redux/Ffilemonitoring/action";
import { MdOutlineFileCopy } from "react-icons/md";

const predefinedBottomRanges = [
    {
        label: 'Today',
        value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
        placement: 'left'
    },
    {
        label: 'Yesterday',
        value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
        placement: 'left'
    },
    {
        label: 'This week',
        value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 7 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 30 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
        placement: 'left'
    },
    {
        label: 'This month',
        value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last month',
        value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
    },
    {
        label: 'This year',
        value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
        placement: 'left'
    },
    {
        label: 'Last year',
        value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
        placement: 'left'
    },

    {
        label: 'Last week',
        closeOverlay: false,
        value: value => {
            const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
            ];
        },
        appearance: 'default'
    },
    {
        label: 'Next week',
        closeOverlay: false,
        value: value => {
            const [start = new Date()] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
            ];
        },
        appearance: 'default'
    }
];



 const CopyButton = (props)=> {
    const {copyText = ''} = props
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button onClick={handleCopy}
              style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  cursor: "pointer"
              }} >
        <MdOutlineFileCopy  size={18}/>
      </button>

      {copied && (
        <span style={{fontSize:'12px'}} >
          Copied!
        </span>
      )}
    </div>
  );
}


const ExceptionRecord = () => {
    const [loader] = useState({ id: null, type: null });
    const [colorRow, setColorRow] = useState({});
    const [toastMessage, setToastMessage] = useState({ status: false, message: "", type: "" });
    const [isSwal, setIsSwal] = useState({ status: false, message: "" });
    const [exportLoader, setExportLoader] = useState(false);
    const [monitordata, setMonitorData] = useState([]);
    const [isFocusedStatus, setIsFocusedStatus] = useState(false);
    const [exceptionModal, setExceptionModal] = useState({ show: false, message: "", title: "" });

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>
                 {searchFormik.values?.[state]?.value ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };


    const defaultColumns = {
        // 'Sl. No': true,
          'Created Date': true,
         'Created By': true,
         'Module': true,
         'Function': true,
        'Error Message': true,
       
    };

    const [state, setState] = useState(defaultColumns);



    const initialFilters = {
        search: "",
        created_date: null,
        function: "",
        module: "",
        created_by: "",
    };



    const {
        searchFormik,
        data,
        loading,
        pageNo,
        limit,
        totalRows,
        handleSearch,
        handlePageChange,
        handlePerRowsChange,
        handleSort,
        setSearchedData,
        searchedData,
        fetchData,
        setPageNo,
    } = useFilter(initialFilters, getExceptionRecordTable);

    const handleCustomReset = () => {
        searchFormik.resetForm();
        handleSearch(initialFilters);
    };



    const columns = useMemo(
        () => [


            {
                name: "Sl. No",
                selector: (row, index) => (pageNo - 1) * limit + index + 1,
                sortable: false,
                width: '50px',
                
            },


            {
                id: 'created_date',
                name: 'Created Date',
                selector: row => row?.created_date,
                cell: (row) => (
                    <span onClick={() => handleRowCheckClick(row)}>
                        {row?.created_date}
                    </span>
                ),
                sortable: true,
                // grow: 2,
                width: '120px',
                omit: !state?.['Created Date']
            },

            {
                id: 'created_by',
                name: 'Created By',
                selector: row => row?.created_by,
                cell: (row) => (
                    <span onClick={() => handleRowCheckClick(row)}>
                        {row?.created_by}
                    </span>
                ),
                sortable: true,
                left: true,
                omit: !state?.['Created By']
            },

            {
                id: 'module',
                name: 'Module',
                selector: row => row?.module,
                cell: (row) => (
                    <Tooltip title={row.module}>
                    <span onClick={() => handleRowCheckClick(row)} className="cursor-pointer">
                        {row?.module}
                    </span>
                    </Tooltip>
                ),
                sortable: true,
                left: true,
                omit: !state?.['Module']
            },


            {
                id: 'function',
                name: 'Function',
                selector: row => row.function,
                cell: (row) => (
                    <Tooltip title={row.function}>
                    <span onClick={() => handleRowCheckClick(row)} className="cursor-pointer">
                        {row.function}
                    </span>
                    </Tooltip>
                ),
                sortable: true,
                wrap: true,
                grow: 4 ,
                omit: !state?.['Function']
            },



            {
                id: 'exception_message',
                name: 'Error Message',
                selector: row => row?.exception_message,
                cell: (row) => {
                    const message = row?.exception_message;
                    if (!message) return "-";
                    
                        return (
                        
                            <div 
                                onClick={() => {
                                    handleRowCheckClick(row);
                                    setExceptionModal({ 
                                        show: true, 
                                        message: message, 
                                        title: row.module ? `Error Message: ${row.module}` : "Error Message" 
                                    });
                                }} 
                                className="cursor-pointer d-flex flex-column py-2"
                                style={{ minWidth: '200px'}}
                            >
                                <div className="text-truncate text-dark" style={{ maxWidth: '650px' }}>
                                    {message}
                                </div>
                             
                            </div>
                            
                        );
                
                },
                sortable: true,
                wrap: true,
                grow: 12,
                omit: !state?.['Error Message']
            },



        ],
        [state, pageNo, limit]
    );

    const conditionalRowStyles = [
        {
            when: row => colorRow?.id === row?.id,
            style: {
                backgroundColor: '#dbf4f5',
            },
        }
    ];

    const handleRowCheckClick = (row) => {
        setColorRow(row);
    };


    const handleOnDateTimeChange = (value) => {
        searchFormik.setFieldValue("created_date", value);

        if (searchFormik.values.exception_type) {
            const newSearch = {
                ...searchFormik.values,
                created_date: value
            };

            handleSearch(newSearch);
        }
    };




    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toastMessage} />

            <ToastContainer className="p-3" position={"top-end"}>
                <Toast
                    bg={toastMessage?.type}
                    onClose={() => setToastMessage({ status: false, message: "", type: "" })}
                    show={toastMessage?.status}
                    animation={true}
                    delay={2000}
                    autohide
                >
                    <Toast.Body><span className='text-white'>{toastMessage?.message}</span></Toast.Body>
                </Toast>
            </ToastContainer>

            {isSwal.status && (
                <SweetAlert
                    danger
                    confirmBtnText="Ok!"
                    confirmBtnCssClass="custom-confirm-button-class"
                    onConfirm={() => setIsSwal({ status: false, message: "" })}
                >
                    <span className="fw-bold">{isSwal.message}</span>
                </SweetAlert>
            )}

            <main id="main" className="main">
                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>Exception Records</h1>
                </div>

                <section className="section mt-5">
                    <div className="row align-items-top gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">
                                <div className='card-header'>
                                    <div className="d-flex align-items-center position-relative ms-4">
                                        <FilterComponent
                                            formik={searchFormik}
                                            onReset={handleCustomReset}
                                            extraAction={
                                                <div className="d-flex">
                                                    <div className="me-2">
                                                        <TableHeadings
                                                            columnState={state}
                                                            setColumnState={setState}
                                                        />
                                                    </div>

                                                </div>
                                            }
                                        >
                                            <div className="d-flex align-items-center gap-3">
                                              


                                                      
                                                <input
                                                    id="created_by"
                                                    className="form-control form-control-solid b-r-10"
                                                    name='created_by'
                                                    type="search"
                                                    style={{ width: "180px", fontSize: "15px", height: "38px" }}
                                                    placeholder="Search Created By"
                                                    aria-label="Created By Search"
                                                    value={searchFormik.values?.created_by}
                                                    onChange={searchFormik.handleChange}
                                                />


                                                <input
                                                    id="module"
                                                    className="form-control form-control-solid b-r-10"
                                                    name='module'
                                                    type="search"
                                                    style={{ width: "180px", fontSize: "15px", height: "38px" }}
                                                    placeholder="Search Module"
                                                    aria-label="Function Search"
                                                    value={searchFormik.values?.module}
                                                    onChange={searchFormik.handleChange}
                                                />

                                                   <input
                                                    id="function"
                                                    className="form-control form-control-solid b-r-10"
                                                    name='function'
                                                    type="search"
                                                    style={{ width: "180px", fontSize: "15px", height: "38px" }}
                                                    placeholder="Search Function"
                                                    aria-label="Function Search"
                                                    value={searchFormik.values?.function}
                                                    onChange={searchFormik.handleChange}
                                                />


                                                <div className='' >
                                                    <Tooltip title="Created Date" placement="top" disableInteractive>
                                                        <Stack direction="column" spacing={8} alignItems="flex-start">
                                                            <DateRangePicker
                                                                ranges={predefinedBottomRanges}
                                                                cleanable={true}
                                                                placement='auto'
                                                                appearance="default"    
                                                                defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                                format={"MM/dd/yyyy HH:mm"}
                                                                placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                                className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                                name="created_date"
                                                                style={{ height: "38px" }}
                                                                onChange={(value) => { handleOnDateTimeChange(value) }}
                                                                value={searchFormik?.values?.created_date}
                                                            />
                                                        </Stack>
                                                    </Tooltip>
                                                </div>
                                            </div>


                                        </FilterComponent>
                                    </div>
                                </div>


                                <div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            <DataTable
                                                className="custom-datatable"
                                                fixedHeader
                                                fixedHeaderScrollHeight="calc(100vh - 280px)"
                                                data={data?.results}
                                                columns={columns}
                                                progressPending={loading}
                                                progressComponent={<div className="p-5">Loading...</div>}
                                                noDataComponent={<div className="p-5 text-muted">No exception records found</div>}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                sortServer
                                                onSort={handleSort}
                                                // defaultSortFieldId="created_date"
                                                // defaultSortAsc={false}
                                                paginationPerPage={limit}
                                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                conditionalRowStyles={conditionalRowStyles}
                                                onRowClicked={handleRowCheckClick}
                                                theme="solarized"
                                                customStyles={queueDatatableCustomStyles}
                                                pointerOnHover
                                                striped
                                                highlightOnHover
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Modal
                show={exceptionModal.show}
                onHide={() => setExceptionModal({ ...exceptionModal, show: false })}
                centered
                size="lg"
                // backdrop="static"
                className="exception-summary-modal"
                keyboard={true}     // allow ESC    
            >
                <Modal.Header closeButton className="bg-white border-bottom-0 pt-3 px-4">
                    <Modal.Title>
                        <div className="d-flex justify-content-center gap-3" >
                            <p className="fw-bold fs-5 text-dark">{exceptionModal.title}</p>
                            <CopyButton copyText={exceptionModal.message} />
                        </div>
                            
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-4 pt-1 px-4">
                    {/* <p className="text-muted small mb-2">Error Message</p> */}
                    <div 
                        className="custom-scroll p-4 rounded-3 bg-light text-dark shadow-sm" 
                        style={{ 
                            maxHeight: '70vh', 
                            overflowY: 'auto',
                            // whiteSpace: 'pre-wrap',
                            // lineHeight: '1.6',
                            // wordBreak: 'break-word',
                            fontSize: '12px',
                            border: '1px solid #e5e7eb',
                            // letterSpacing: '0.3px'
                        }}

                    >
                        {exceptionModal.message}
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0 pb-4 px-4">
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

export default ExceptionRecord;